var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header" },
        [
          _c("Core-Title", { attrs: { loading: _vm.listLoading } }, [
            _c("h2", [_vm._v("Facturas no procesadas por error")]),
          ]),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade-to-top", appear: "" } },
        [
          _c(
            "el-card",
            { staticClass: "is-table" },
            [
              _c("BillingErrors-FilesList"),
              _c("Core-Pagination", {
                attrs: {
                  pageSize: _vm.pageSize,
                  totalElements: _vm.totalElements,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("transition", { attrs: { name: "fade-to-top", appear: "" } }, [
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c("BillingErrors-PageSizeSelect", {
              on: { change: _vm.onChangePageSize },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }